// import green from "@material-ui/core/colors/green";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import React, { useEffect } from "react";
import ThreeDots from "./ThreeDots";

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export default function ConfirmBooking(props) {
  const classes = useStyles();
  {
    /*........................................................|...............
  .............final values to pass to backend and...........\|/..............
  .............get response(registration ID, bookingDate).....V...............*/
  }
  const [readyFormValues] = React.useState(props.values);
  {
    /*..........................................|...............
  .............trigger Initial loader before ..\|/..............
  .............showing error or success.........V...............
  ..............................................................*/
  }
  const [loading, setLoading] = React.useState(true);

  {
    /*.........................................................|...............
  .............to store response after successful booking.....\|/..............
  .............................................................V...............*/
  }
  const [resp, setResp] = React.useState({});
  const [responseReceived, triggerResponseReceived] = React.useState(false);
  {
    /*.................................................................|...............
  .............to store error response after unsuccessful booking.....\|/..............
  .....................................................................V...............*/
  }
  const [errorRespMsg, setErrorResp] = React.useState("");
  const [errorOccur, triggerErrorOccur] = React.useState(false);

  async function fetchData() {
    try {
      let res = await axios.post(
        "http://localhost:8002/eventRegistration/booking/bookEvent",
        readyFormValues
      );
      setResp(res.data);
      displaySuccess();
    } catch (error) {
      setErrorResp(error.response.data.message);
      displayError();
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  async function displaySuccess() {
    await sleep(1500);
    setLoading(false); //........................closing loader....................
    triggerResponseReceived(true); //............trigger success message block.....
  }
  async function displayError() {
    await sleep(1500);
    setLoading(false); //........................closing loader....................
    triggerErrorOccur(true); //..................trigger error message block.......
  }
  const pageReload = () => {
    window.location.reload(); //..........triggerd when user click on "make another booking button"........
  };
  return (
    <React.Fragment>
      {/*..........................................|...............
         .............Initial three dots loader...\|/..............
         ..........................................V...............*/}
      {loading ? (
        <Typography variant="h6">
          Hold on! Confirming your booking &nbsp;
          <ThreeDots color="blue" height={80} width={80} />
        </Typography>
      ) : (
        <div></div>
      )}
      {/*..........................................^...............
         .............Initial three dots loader.../|\..............
         ..........................................|...............*/}
      {/*................................................................................................................................
         ................................................................................................................................*/}
      {/*..........................................|...............
         .............success message block.......\|/..............
         ..........................................V...............*/}
      {responseReceived ? (
        <React.Fragment>
          <Typography variant="h6" color="secondary">
            {resp.message}
          </Typography>
          <Typography variant="h6" gutterBottom>
            {/*........................................................................|...............
               ........passing/showing registration ID recieved from backend here.....\|/..............
               ........................................................................V...............*/}
            Your registration number is:
            <Typography variant="h6" color="secondary">
              {resp.bookingId}
            </Typography>
            {/*........................................................................|...............
               ........passing/showing booking date recieved from backend here........\|/..............
               ........................................................................V...............*/}
            Your booking date is: {resp.bookingDate.join("-")} <br />
            Thank you {readyFormValues.fullName} for registering for this event.
            <br />
            An account has been created with the provided details(In case you
            are a new user). <br />
            Check your email for password and ticket details (also you check
            your dashboard for the tickets).
          </Typography>
        </React.Fragment>
      ) : (
        <div></div>
      )}
      {/*..........................................^...............
         .............success message block......./|\..............
         ..........................................|...............*/}
      {/*................................................................................................................................
         ................................................................................................................................*/}
      {/*..........................................|...............
         .............error message block.........\|/..............
         ..........................................V...............*/}
      {errorOccur ? (
        <React.Fragment>
          <Typography variant="h6">{errorRespMsg}</Typography>
        </React.Fragment>
      ) : (
        <div></div>
      )}
      {/*..........................................^...............
         .............error message block........./|\..............
         ..........................................|...............*/}
      {/*................................................................................................................................
         ................................................................................................................................*/}

      <div className={classes.buttons}>
        {/*........................................................................|...............
           ........reloads the parent page to accept new fresh booking............\|/..............
           ........................................................................V...............*/}
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={pageReload}
        >
          Make another booking
        </Button>
        {/*................................................................................|...............
           ........attach where you want the user to direct after clicking................\|/..............
           ........on close(in future may add main homepage to show available events)......V...............*/}
        <Button variant="contained" color="primary" className={classes.button}>
          Close
        </Button>
      </div>
    </React.Fragment>
  );
}
